import { useCreditCardSetupContext } from '@apps/registry/admin/components/CreditCardSetup/CreditCardSetUp.context';
import { useShippingAddressAndCurrencyDialogsContext } from '../components/ShippingAddressAndCurrencyDialogsProvider';

export const useShouldShowConnectBankAccountButton = () => {
  const { registryShippingAddress } = useShippingAddressAndCurrencyDialogsContext();
  const { payoutAccountInfo } = useCreditCardSetupContext();

  if (!registryShippingAddress) {
    return false;
  }

  if (registryShippingAddress.countryCode !== 'USA') {
    return false;
  }

  if (!payoutAccountInfo || (payoutAccountInfo.status !== 'pending' && payoutAccountInfo.status !== 'readyToUse')) {
    return true;
  }

  return false;
};
